// Elektrik Mock Data
// Elektrik malzemeleri, kablo, pano ve aydınlatma takibi

export const elektrikMalzemeler = [
    {
        id: 'el-001',
        siparisTarihi: '2026-01-10',
        teslimTarihi: '2026-01-12',
        tedarikci: 'Prysmian Kablo',
        tedarikciFirmaId: 'f-040',
        kategori: 'kablo',
        urunAdi: 'NYY 3x2.5 mm²',
        aciklama: 'Aydınlatma kablosu',
        miktar: 2000,
        birim: 'metre',
        birimFiyat: 45,
        toplamFiyat: 90000,
        durum: 'teslim',
        stokMiktar: 800,
        kullanilanMiktar: 1200,
        uygulamaYeri: 'A Blok Ortak Alan',
        insaatId: 'c-001',
        not: 'Koridor ve merdiven aydınlatması',
        createdAt: '2026-01-10T09:00:00Z',
        updatedAt: '2026-01-16T15:00:00Z',
    },
    {
        id: 'el-002',
        siparisTarihi: '2026-01-10',
        teslimTarihi: '2026-01-12',
        tedarikci: 'Prysmian Kablo',
        tedarikciFirmaId: 'f-040',
        kategori: 'kablo',
        urunAdi: 'NYY 5x6 mm²',
        aciklama: 'Priz hattı kablosu',
        miktar: 1500,
        birim: 'metre',
        birimFiyat: 120,
        toplamFiyat: 180000,
        durum: 'teslim',
        stokMiktar: 500,
        kullanilanMiktar: 1000,
        uygulamaYeri: 'A Blok Daireler',
        insaatId: 'c-001',
        not: 'Daire priz tesisatı',
        createdAt: '2026-01-10T09:00:00Z',
        updatedAt: '2026-01-17T14:00:00Z',
    },
    {
        id: 'el-003',
        siparisTarihi: '2026-01-05',
        teslimTarihi: '2026-01-08',
        tedarikci: 'Legrand Türkiye',
        tedarikciFirmaId: 'f-041',
        kategori: 'pano',
        urunAdi: 'Ana Dağıtım Panosu',
        aciklama: '630A Ana Pano',
        miktar: 1,
        birim: 'adet',
        birimFiyat: 85000,
        toplamFiyat: 85000,
        durum: 'teslim',
        stokMiktar: 0,
        kullanilanMiktar: 1,
        uygulamaYeri: 'A Blok Elektrik Odası',
        insaatId: 'c-001',
        montajDurumu: 'tamamlandi',
        not: 'Montaj ve test tamamlandı',
        createdAt: '2026-01-05T10:00:00Z',
        updatedAt: '2026-01-15T16:00:00Z',
    },
    {
        id: 'el-004',
        siparisTarihi: '2026-01-12',
        teslimTarihi: '2026-01-14',
        tedarikci: 'Legrand Türkiye',
        tedarikciFirmaId: 'f-041',
        kategori: 'pano',
        urunAdi: 'Daire Dağıtım Panosu',
        aciklama: '24 Modül Sıva Altı',
        miktar: 20,
        birim: 'adet',
        birimFiyat: 1200,
        toplamFiyat: 24000,
        durum: 'teslim',
        stokMiktar: 8,
        kullanilanMiktar: 12,
        uygulamaYeri: 'A Blok Daireler',
        insaatId: 'c-001',
        montajDurumu: 'devam',
        not: '12 daire montajı tamamlandı',
        createdAt: '2026-01-12T11:00:00Z',
        updatedAt: '2026-01-17T17:00:00Z',
    },
    {
        id: 'el-005',
        siparisTarihi: '2026-01-15',
        teslimTarihi: null,
        tedarikci: 'Philips Aydınlatma',
        tedarikciFirmaId: 'f-042',
        kategori: 'aydinlatma',
        urunAdi: 'LED Panel 60x60',
        aciklama: '40W Sıva Altı Panel',
        miktar: 100,
        birim: 'adet',
        birimFiyat: 450,
        toplamFiyat: 45000,
        durum: 'bekliyor',
        stokMiktar: 0,
        kullanilanMiktar: 0,
        uygulamaYeri: 'A Blok Ortak Alan',
        insaatId: 'c-001',
        montajDurumu: 'bekliyor',
        not: 'Asma tavan bitince montaj',
        createdAt: '2026-01-15T14:00:00Z',
        updatedAt: '2026-01-15T14:00:00Z',
    },
    {
        id: 'el-006',
        siparisTarihi: '2026-01-08',
        teslimTarihi: '2026-01-09',
        tedarikci: 'Viko',
        tedarikciFirmaId: 'f-043',
        kategori: 'anahtar-priz',
        urunAdi: 'Anahtar Priz Seti',
        aciklama: 'Linnera Serisi Beyaz',
        miktar: 500,
        birim: 'adet',
        birimFiyat: 85,
        toplamFiyat: 42500,
        durum: 'teslim',
        stokMiktar: 200,
        kullanilanMiktar: 300,
        uygulamaYeri: 'A Blok Daireler',
        insaatId: 'c-001',
        montajDurumu: 'devam',
        not: 'Boyadan sonra montaj',
        createdAt: '2026-01-08T10:00:00Z',
        updatedAt: '2026-01-16T12:00:00Z',
    },
];

// Elektrik kategorileri
export const elektrikKategorileri = [
    { key: 'kablo', label: 'Kablo', icon: '🔌' },
    { key: 'pano', label: 'Pano', icon: '📦' },
    { key: 'aydinlatma', label: 'Aydınlatma', icon: '💡' },
    { key: 'anahtar-priz', label: 'Anahtar/Priz', icon: '🔲' },
    { key: 'topraklama', label: 'Topraklama', icon: '⚡' },
];

// Montaj durumları
export const montajDurumlari = [
    { key: 'bekliyor', label: 'Bekliyor', color: 'info' },
    { key: 'devam', label: 'Devam Ediyor', color: 'warning' },
    { key: 'tamamlandi', label: 'Tamamlandı', color: 'success' },
];

// İstatistikler
export const getElektrikStats = (insaatId) => {
    const filtered = insaatId
        ? elektrikMalzemeler.filter(s => s.insaatId === insaatId)
        : elektrikMalzemeler;

    const toplamKalem = filtered.length;
    const teslimEdilen = filtered.filter(s => s.durum === 'teslim').length;
    const bekleyen = filtered.filter(s => s.durum === 'bekliyor').length;
    const toplamMaliyet = filtered.reduce((acc, s) => acc + s.toplamFiyat, 0);

    // Kategori bazlı özet
    const kategoriler = {};
    filtered.forEach(s => {
        if (!kategoriler[s.kategori]) {
            kategoriler[s.kategori] = { adet: 0, tutar: 0 };
        }
        kategoriler[s.kategori].adet++;
        kategoriler[s.kategori].tutar += s.toplamFiyat;
    });

    return {
        toplamKalem,
        teslimEdilen,
        bekleyen,
        toplamMaliyet,
        kategoriler,
    };
};

// Helper: insaata göre filtrele
export const getElektrikByInsaat = (insaatId) => {
    if (!insaatId) return elektrikMalzemeler;
    return elektrikMalzemeler.filter(s => s.insaatId === insaatId);
};

// Helper: kategoriye göre filtrele
export const getElektrikByKategori = (kategori, insaatId) => {
    let data = insaatId ? getElektrikByInsaat(insaatId) : elektrikMalzemeler;
    if (kategori) {
        data = data.filter(s => s.kategori === kategori);
    }
    return data;
};
